import { Route, Routes } from 'react-router-dom';
import Page404 from '../../views/user/Auth/Page404';
import NavGrievanceTickets from '../../views/Grievance/NavGrievanceTickets';
import { useSelector } from 'react-redux';
import useRoles from '../../Hooks/useRoles';
import CimsLanding from '../../views/CIMS/CimsLanding';

const CimsRouter = () => {
  useRoles('CIMS');
  const role = useSelector((state) => state.role);

  return (
    <Routes>
      {role.navChild.includes('CIMS Admin') && (
        <Route path="cims-admin" element={<CimsLanding isAdmin />} />
      )}
      <Route path="client-Interactions" element={<CimsLanding />} />

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default CimsRouter;
